import app from 'flarum/forum/app';
import highlight from 'flarum/common/helpers/highlight';
import Button from 'flarum/common/components/Button';
export default class DiscussionSearchSource {
  results = (() => new Map())();
  constructor(onSelect, ignore) {
    this.onSelect = onSelect;
    this.ignore = ignore;
  }
  async search(rawQuery) {
    const query = this.normalizeQuery(rawQuery);
    this.results.set(query, []);
    if (!query) {
      m.redraw();
      return;
    }
    try {
      const results = this.isIdQuery(query) ? await this.searchById(query) : await this.searchByQuery(query);
      this.results.set(query, results);
    } catch {
      this.results.set(query, []);
    } finally {
      m.redraw();
    }
  }
  view(rawQuery) {
    const query = this.normalizeQuery(rawQuery);
    const results = this.results.get(query) ?? [];
    return results.map(discussion => {
      const discussionId = discussion.id();
      if (!discussionId) return null;
      return m("li", {
        key: discussionId,
        className: "DiscussionSearchResult",
        "data-index": `discussions${discussionId}`
      }, m(Button, {
        onclick: () => this.onSelect(discussion)
      }, m("div", {
        className: "DiscussionSearchResult-id"
      }, discussionId), m("div", {
        className: "DiscussionSearchResult-title"
      }, highlight(discussion.title(), query))));
    });
  }
  async searchById(id) {
    if (id === this.ignore) return [];
    const discussion = await app.store.find('discussions', id);
    return discussion ? [discussion] : [];
  }
  async searchByQuery(query) {
    const results = await app.store.find('discussions', {
      filter: {
        q: query
      },
      page: {
        limit: this.limit()
      }
    });
    return results.filter(discussion => discussion.id() !== this.ignore);
  }
  isIdQuery(query) {
    return /^\d+$/.test(query);
  }
  normalizeQuery(query) {
    return query.trim().toLowerCase();
  }
  limit() {
    return 3;
  }
}
flarum.reg.add('fof-ui-kit', 'forum/components/DiscussionSearchSource', DiscussionSearchSource);